import { collectNumbers, numericExtent, anchoredVwapSeries } from "../utils";
const AnchoredVWAP = {
    name: "AnchoredVWAP",
    compute: (bars, anchorTime = 0, showBands = true, multiplier = 1) => anchoredVwapSeries(bars, anchorTime, showBands, multiplier),
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default AnchoredVWAP;
